//ThemeToggle.js
import { useContext } from "react";
import { MoonIcon, LightBulbIcon } from "@heroicons/react/24/solid";
import { ThemeContext } from "./ThemeContext";

const Toggle = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <div className="transition duration-500 ease-in-out">
      {theme === "dark" ? (
        <LightBulbIcon
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="h-6 w-6 text-gray-500 dark:text-yellow-400 text-2xl cursor-pointer"
        />
      ) : (
        <MoonIcon
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="h-6 w-6 text-gray-800 dark:text-gray-400 text-2xl cursor-pointer"
        />
      )}
    </div>
  );
};

export default Toggle;
